module.exports = __webpack_public_path__ + "img/client_bayer.16292c72.svg";